export const IB_TREES_FETCH = 'IB_TREES_FETCH';
export const IB_TREES_IS_FETCING = 'IB_TREES_IS_FETCHING';
export const IB_TREES_API = `profiles/$profileId/ibtree`;
export const IB_TREE_EDIT = 'IB_TREE_EDIT';
export const IB_TREE_SAVE = 'IB_TREE_SAVE';
export const IB_TREE_FILTER = 'IB_TREE_FILTER';
export const SET_IBTREE_PROFILE = 'SET_IBTREE_PROFILE';
export const SET_IBTREE_IB = 'SET_IBTREE_IB';


// WEBPACK FOOTER //
// ./src/constants/ibTrees.js